import { Theme } from '../types/enums';
import { NextgenDOMPurify } from '../utils/NextgenDOMPurify/NextgenDOMPurify';
import styles from './CSTable.module.scss';
import type { CSTableProptype, CSTableRowItem, CSTableColumnItem } from './types/propsType';

const CSTable: React.FC<CSTableProptype> = ({
  theme = Theme.WHITE,
  columnList,
  footer,
  rowData,
  title,
  configLabel,
}: CSTableProptype) => {
  const sanitizedHTML = NextgenDOMPurify(footer || '', { ADD_ATTR: ['target'] });
  const { columnLabel, rowLabel } = configLabel;
  return (
    <>
      {!!title && <p className={styles['cms-table-title']}>{title}</p>}
      <table className={styles['cms-table-copmonent']} data-testid="CSTable-test-id">
        <tr>
          {columnList.map((column) => (
            <th key={`${column[columnLabel]}`}>{column[columnLabel] as string}</th>
          ))}
        </tr>
        {rowData.map((item, index) => (
          <tr className={`${styles[theme]}`} key={`row-${item.length - index}`}>
            {item.map((subItem, index) => (
              <td key={`${subItem[rowLabel]}`} className={!index ? styles['row-data-highlight'] : ''}>
                <div className={styles['row-data-height']}>{subItem[rowLabel] as string}</div>
              </td>
            ))}
          </tr>
        ))}
      </table>
      {!!sanitizedHTML && (
        <div className={styles['cms-table-footer']} dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
      )}
    </>
  );
};
CSTable.displayName = 'CSTable';
export type { CSTableRowItem, CSTableColumnItem, CSTableProptype };
export default CSTable;
